module.exports = {
      id: "share-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#share",
      toString: function () {
        return this.url;
      }
    }